const apiKey = 'AIzaSyA4E2UFGoEiaWeAXayur6HqB0lMbke3Ujw'; // YOUCA Key

const mapOptions: google.maps.MapOptions = {
  zoomControl: true,
  disableDefaultUI: true,
  maxZoom: 18,
  minZoom: 5,
  center: { lat: 48.15806967688501, lng: 16.382443657662837 }
};

export const googleMapsConfig = {
  apiKey,
  mapOptions
};
